import {
  setListsLoading,
  setListsSuccess,
  setListsError,
  setListLoading,
  setListSuccess,
  setListError,
  setActiveListLoading,
  setActiveListSuccess,
  setActiveListError,
  addListToStoreLoading,
  addListToStoreSuccess,
  addListToStoreFail,
  renameListLoading,
  renameListSuccess,
  renameListFail,
  deleteListLoading,
  deleteListSuccess,
  deleteListFail,
  toggleListLockLoading,
  toggleListLockSuccess,
  toggleListLockFail,
  toggleListActivateLoading,
  toggleListActivateSuccess,
  toggleListActivateFail,
  getActiveListLoading,
  getActiveListSuccess,
  getActiveListError,
  setListItemsLoading,
  setListItemsSuccess,
  setListItemsFail,
  setListOrderPreferenceLoading,
  setListOrderPreferenceSuccess,
  setListOrderPreferenceFail,
  setPlaceOrderCommentsLoading,
  setPlaceOrderCommentsSuccess,
  setPlaceOrderCommentsFail,
} from "../../reducers/Store/list";

export const addList = (list) => async (dispatch) => {
  try {
    dispatch(addListToStoreLoading());
    dispatch(addListToStoreSuccess(list));
  } catch (error) {
    dispatch(addListToStoreFail(error));
  }
};
export const renameList =
  ({ list_id, newName }) =>
  async (dispatch) => {
    try {
      dispatch(renameListLoading());
      dispatch(renameListSuccess({ listId: list_id, newName: newName }));
    } catch (error) {
      dispatch(renameListFail(error));
    }
  };

export const deleteList = (list_id) => async (dispatch) => {
  try {
    dispatch(deleteListLoading());
    dispatch(deleteListSuccess(list_id));
  } catch (error) {
    console.error(error);
    dispatch(deleteListFail("Failed to archive list"));
  }
};
export const setList = (list) => async (dispatch) => {
  try {
    dispatch(setListLoading());
    dispatch(setListSuccess(list));
  } catch (error) {
    console.error(error);
    dispatch(setListError("Failed to set List"));
  }
};
export const setLists = (lists) => async (dispatch) => {
  try {
    dispatch(setListsLoading());
    dispatch(setListsSuccess(lists));
  } catch (error) {
    console.error(error);
    dispatch(setListsError("Failed to set Lists"));
  }
};
export const setListItems = (listItems) => async (dispatch) => {
  try {
    dispatch(setListItemsLoading());
    dispatch(setListItemsSuccess(listItems));
  } catch (error) {
    console.error(error);
    dispatch(setListItemsFail("Failed to set List Items"));
  }
};
export const setActiveList = (list) => async (dispatch) => {
  try {
    dispatch(setActiveListLoading());
    dispatch(setActiveListSuccess(list));
  } catch (error) {
    console.error(error);
    dispatch(setActiveListError("Failed to set Active List"));
  }
};
export const getActiveList = (list) => async (dispatch) => {
  try {
    dispatch(getActiveListLoading());
    dispatch(getActiveListSuccess(list));
  } catch (error) {
    console.error(error);
    dispatch(getActiveListError("Failed to get Active List"));
  }
};
export const lockList =
  ({ list_id, newLockStatus }) =>
  async (dispatch) => {
    try {
      dispatch(toggleListLockLoading());

      dispatch(
        toggleListLockSuccess({ listId: list_id, newLockStatus: newLockStatus })
      );
    } catch (error) {
      console.error(error);
      dispatch(toggleListLockFail("Failed to toggle lock status"));
    }
  };
export const activateList =
  ({ list_id, status }) =>
  async (dispatch) => {
    try {
      dispatch(toggleListActivateLoading());

      dispatch(toggleListActivateSuccess({ listId: list_id, status: status }));
    } catch (error) {
      console.error(error);
      dispatch(toggleListActivateFail("Failed to toggle activate status"));
    }
  };
export const setListOrderPreference = (preference) => async (dispatch) => {
  try {
    dispatch(setListOrderPreferenceLoading());
    dispatch(setListOrderPreferenceSuccess({ preference }));
  } catch (error) {
    console.error(error);
    dispatch(setListOrderPreferenceFail("Failed to get Active List"));
  }
};

export const setListOrderComments = (comments) => async (dispatch) => {
  try {
    dispatch(setPlaceOrderCommentsLoading());
    dispatch(setPlaceOrderCommentsSuccess({ comments }));
  } catch (error) {
    console.error(error);
    dispatch(setPlaceOrderCommentsFail("Failed to set  List comments"));
  }
};
